module.exports = __webpack_public_path__ + "static/media/A (6).e9b63348.jpg";